fragment BillingInfo on BillingInfo {
    phoneNumber
    phoneNumberFormatted
    email
    companyName
    firstName
    lastName
    displayName
    isNewSubscription
    isValid
    bankInfo {
        accountType
        accountNumber
        nameOnAccount
        routingNumber
    }
    cardInfo {
        lastFourDigits
        firstName
        lastName
        expirationMonth
        expirationYear
        cardType
    }
    addressInfo {
        address1
        address2
        city
        postal
        state
        country
    }
}
